import { render } from "./OffersSection.vue?vue&type=template&id=25bc261d&scoped=true"
import script from "./OffersSection.vue?vue&type=script&lang=js"
export * from "./OffersSection.vue?vue&type=script&lang=js"

import "./OffersSection.vue?vue&type=style&index=0&id=25bc261d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bc261d"]])

export default __exports__